export type NotificationDetailLine={label?:string;value:string};

export function uniqueQcNotificationLines(lines:NotificationDetailLine[]){
  const field=(label:string)=>lines.find(line=>line.label?.toLowerCase()===label)?.value.trim();
  const submittedBy=field('submitted by')?.toLowerCase();
  const scopeTarget=field('scope')?.split('·').slice(1).map(value=>value.trim().toLowerCase())||[];
  const seen=new Set<string>();
  return lines.filter(line=>{
    const label=line.label?.toLowerCase();
    if(!label)return true;
    if(label==='employee'&&submittedBy===line.value.trim().toLowerCase())return false;
    if(label==='target'&&scopeTarget.includes(line.value.trim().toLowerCase()))return false;
    if(seen.has(label))return false;
    seen.add(label);
    return true;
  });
}

// Daily report snapshots can contain the original submission plus appended details.
export function uniqueDailyNotificationLines(lines:NotificationDetailLine[]){
  return uniqueQcNotificationLines(lines);
}

// Remove only identical structured fields. Distinct values and free text are retained.
export function uniqueNotificationLines(lines:NotificationDetailLine[]){
  const seen=new Set<string>();
  return lines.filter(line=>{
    const label=line.label?.trim().toLowerCase();
    if(!label||['details','request','objection'].includes(label))return true;
    const key=JSON.stringify([label,line.value.trim()]);
    if(seen.has(key))return false;
    seen.add(key);
    return true;
  });
}
